(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@tonaljs/abc-notation'), require('@tonaljs/array'), require('@tonaljs/chord'), require('@tonaljs/chord-type'), require('@tonaljs/collection'), require('@tonaljs/core'), require('@tonaljs/duration-value'), require('@tonaljs/interval'), require('@tonaljs/key'), require('@tonaljs/midi'), require('@tonaljs/mode'), require('@tonaljs/note'), require('@tonaljs/pcset'), require('@tonaljs/progression'), require('@tonaljs/range'), require('@tonaljs/roman-numeral'), require('@tonaljs/scale'), require('@tonaljs/scale-type'), require('@tonaljs/time-signature')) :
  typeof define === 'function' && define.amd ? define(['exports', '@tonaljs/abc-notation', '@tonaljs/array', '@tonaljs/chord', '@tonaljs/chord-type', '@tonaljs/collection', '@tonaljs/core', '@tonaljs/duration-value', '@tonaljs/interval', '@tonaljs/key', '@tonaljs/midi', '@tonaljs/mode', '@tonaljs/note', '@tonaljs/pcset', '@tonaljs/progression', '@tonaljs/range', '@tonaljs/roman-numeral', '@tonaljs/scale', '@tonaljs/scale-type', '@tonaljs/time-signature'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.Tonal = {}, global.abcNotation, global.array, global.chord, global.ChordType, global.collection, global.Core, global.durationValue, global.interval, global.key, global.midi, global.mode, global.note, global.Pcset, global.progression, global.range, global.romanNumeral, global.scale, global.ScaleType, global.timeSignature));
}(this, (function (exports, abcNotation, array, chord, ChordType, collection, Core, durationValue, interval, key, midi, mode, note, Pcset, progression, range, romanNumeral, scale, ScaleType, timeSignature) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
      Object.keys(e).forEach(function (k) {
        if (k !== 'default') {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function () {
              return e[k];
            }
          });
        }
      });
    }
    n['default'] = e;
    return Object.freeze(n);
  }

  var abcNotation__default = /*#__PURE__*/_interopDefaultLegacy(abcNotation);
  var array__namespace = /*#__PURE__*/_interopNamespace(array);
  var chord__default = /*#__PURE__*/_interopDefaultLegacy(chord);
  var ChordType__default = /*#__PURE__*/_interopDefaultLegacy(ChordType);
  var collection__default = /*#__PURE__*/_interopDefaultLegacy(collection);
  var Core__namespace = /*#__PURE__*/_interopNamespace(Core);
  var durationValue__default = /*#__PURE__*/_interopDefaultLegacy(durationValue);
  var interval__default = /*#__PURE__*/_interopDefaultLegacy(interval);
  var key__default = /*#__PURE__*/_interopDefaultLegacy(key);
  var midi__default = /*#__PURE__*/_interopDefaultLegacy(midi);
  var mode__default = /*#__PURE__*/_interopDefaultLegacy(mode);
  var note__default = /*#__PURE__*/_interopDefaultLegacy(note);
  var Pcset__default = /*#__PURE__*/_interopDefaultLegacy(Pcset);
  var progression__default = /*#__PURE__*/_interopDefaultLegacy(progression);
  var range__default = /*#__PURE__*/_interopDefaultLegacy(range);
  var romanNumeral__default = /*#__PURE__*/_interopDefaultLegacy(romanNumeral);
  var scale__default = /*#__PURE__*/_interopDefaultLegacy(scale);
  var ScaleType__default = /*#__PURE__*/_interopDefaultLegacy(ScaleType);
  var timeSignature__default = /*#__PURE__*/_interopDefaultLegacy(timeSignature);

  // deprecated (backwards compatibility)
  var Tonal = Core__namespace;
  var PcSet = Pcset__default['default'];
  var ChordDictionary = ChordType__default['default'];
  var ScaleDictionary = ScaleType__default['default'];

  Object.defineProperty(exports, 'AbcNotation', {
    enumerable: true,
    get: function () {
      return abcNotation__default['default'];
    }
  });
  exports.Array = array__namespace;
  Object.defineProperty(exports, 'Chord', {
    enumerable: true,
    get: function () {
      return chord__default['default'];
    }
  });
  Object.defineProperty(exports, 'ChordType', {
    enumerable: true,
    get: function () {
      return ChordType__default['default'];
    }
  });
  Object.defineProperty(exports, 'Collection', {
    enumerable: true,
    get: function () {
      return collection__default['default'];
    }
  });
  exports.Core = Core__namespace;
  Object.defineProperty(exports, 'DurationValue', {
    enumerable: true,
    get: function () {
      return durationValue__default['default'];
    }
  });
  Object.defineProperty(exports, 'Interval', {
    enumerable: true,
    get: function () {
      return interval__default['default'];
    }
  });
  Object.defineProperty(exports, 'Key', {
    enumerable: true,
    get: function () {
      return key__default['default'];
    }
  });
  Object.defineProperty(exports, 'Midi', {
    enumerable: true,
    get: function () {
      return midi__default['default'];
    }
  });
  Object.defineProperty(exports, 'Mode', {
    enumerable: true,
    get: function () {
      return mode__default['default'];
    }
  });
  Object.defineProperty(exports, 'Note', {
    enumerable: true,
    get: function () {
      return note__default['default'];
    }
  });
  Object.defineProperty(exports, 'Pcset', {
    enumerable: true,
    get: function () {
      return Pcset__default['default'];
    }
  });
  Object.defineProperty(exports, 'Progression', {
    enumerable: true,
    get: function () {
      return progression__default['default'];
    }
  });
  Object.defineProperty(exports, 'Range', {
    enumerable: true,
    get: function () {
      return range__default['default'];
    }
  });
  Object.defineProperty(exports, 'RomanNumeral', {
    enumerable: true,
    get: function () {
      return romanNumeral__default['default'];
    }
  });
  Object.defineProperty(exports, 'Scale', {
    enumerable: true,
    get: function () {
      return scale__default['default'];
    }
  });
  Object.defineProperty(exports, 'ScaleType', {
    enumerable: true,
    get: function () {
      return ScaleType__default['default'];
    }
  });
  Object.defineProperty(exports, 'TimeSignature', {
    enumerable: true,
    get: function () {
      return timeSignature__default['default'];
    }
  });
  exports.ChordDictionary = ChordDictionary;
  exports.PcSet = PcSet;
  exports.ScaleDictionary = ScaleDictionary;
  exports.Tonal = Tonal;
  Object.keys(Core).forEach(function (k) {
    if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
      enumerable: true,
      get: function () {
        return Core[k];
      }
    });
  });

  Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=index.js.map
